import { getServerErrorText } from 'shared/lib';
import { EmptyData, ErrorMessage } from 'shared/ui';

import { useGetOwnersQuery } from 'entities/owner';

import { DiscountForm } from '../form';

type Props = Omit<React.ComponentProps<typeof DiscountForm>, 'owners'>;

export function ConnectedDiscountForm(props: Props) {
  const { data, isFetching, error } = useGetOwnersQuery();

  if (isFetching) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <ErrorMessage text={getServerErrorText(error)} />;
  }

  if (data && data.statusCode !== 0) {
    return <ErrorMessage text={data.statusDescription} />;
  }

  if (!data) {
    return <EmptyData />;
  }

  return <DiscountForm {...props} owners={data.owners} />;
}
